import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { DragonBetLogo } from 'src/layouts/LoginPage/logos/DragonBetLogo';
import { DragonBetDarkLogo } from 'src/layouts/LoginPage/logos/DragonBetDarkLogo';
import { DragonbetBrandIcon } from 'src/assets/brandIcons/DragonbetBrandIcon';
import { compliancePopupLogoCssDragonbet } from 'src/domains/common/universes/compliancePopupLogoCss';

export const DragonBetMainLogoWrapper = withConfig(theme => styled('div', { label: 'DragonBetMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
`);

export const DragonBetMainLogo = styled(DragonBetLogo, { label: 'DragonBetMainLogo' })`
    height: 24px;
    margin: 0 auto;
    width: 108px;
    fill: #fff;
`;

export const DragonbetBrandIconWrapper = styled(DragonbetBrandIcon, { label: 'DragonbetBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 24px;
    margin: 0 auto;
    width: 24px;
`;

export const CompliancePopupLogo = styled(DragonBetDarkLogo, { label: 'CompliancePopupLogo' })`
    ${compliancePopupLogoCssDragonbet}
`;
